import { Dialog, Zoom } from '@mui/material';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import { Timeline } from 'antd';
import { Eye, EyeOff } from "lucide-react";
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { FileUploader } from "react-drag-drop-files";
import Draggable from 'react-draggable';
import ReactTimePicker from 'react-time-picker';
import { CartesianGrid, Legend, Line, LineChart, Tooltip, XAxis, YAxis } from 'recharts';
import { FetchAutoCompleteData } from './CustomHooks';
import { CommonApiData, autoCompleteDelay } from './EnvConfig';
import { GetSession } from './criptoUtils';

export const FormButton = (props) => {
    const {
        handleSubmit,
        handleExport,
        handleClear,
        handleSearch,
        handleCancel,
        cancel = false,
        id = null,
        search = false,
        searchText = 'Search',
        inputrefs,
        children,
        save = true,
        Export = true,

        update = false,
        LabelPrint = false,
        handleLabelPrint,
        SeeAndPrint = false,
        handleSeeAndPrint,
        InvoicePrint = false,
        handleInvoicePrint,
        resetText = 'Reset',
        Reset = true,
        saveicon = null,
        isPrint = false,
        PrintText = 'Print',
        isPrint1 = false,
        PrintText1 = 'Print',
        handlePrint,
        handlePrint1,
        savetext = 'Save',
        btn = false,
        buttonText = 'Back',
        handleButton,
        buttonLogo = 'fa fa-arrow-left',
        extraclassname = 'mt-3'
    } = props;

    const baseBtn = `
        inline-flex items-center gap-2 px-4 py-2 text-sm font-semibold
        rounded-lg shadow-sm transition-all duration-200
        focus:outline-none focus:ring-1 focus:ring-offset-2
    `;

    const btnRef = useRef();

    const handleMouseMove = (e) => {
        const rect = btnRef.current.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;

        btnRef.current.style.setProperty("--mouse-x", `${x}px`);
        btnRef.current.style.setProperty("--mouse-y", `${y}px`);
    };

    return (
        <div className={`block md:flex gap-2 flex-wrap ${extraclassname}`}>

            {search && (
                <button
                    type="button"
                    name={id}
                    onClick={handleSearch}
                    ref={(ref) => inputrefs && (inputrefs.current[id] = ref)}
                    className={`${baseBtn} bg-[var(--theme-color)] text-white hover:bg-[var(--brand-dark)] focus:ring-[var(--theme-color)]`}
                >
                    <i className="fa fa-search"></i>
                    {searchText}
                </button>
            )}
            {btn && (
                <button
                    type="button"
                    onClick={handleButton}
                    className="ripple-btn px-4 py-2 bg-black text-white rounded font-medium shadow-md uppercase tracking-wide text-[12px] transition-all hover:shadow-lg duration-300 ease-in-out" >
                    <i className={buttonLogo}></i> {buttonText}
                </button>
            )}
            {save && (
                <>
                    <button
                        onMouseMove={handleMouseMove}
                        name={id}
                        onClick={handleSubmit}
                        ref={(ref) => {
                            btnRef.current = ref;
                            if (inputrefs) inputrefs.current[id] = ref;
                        }}
                        className="ripple-btn px-4 py-2 bg-[var(--theme-color)] text-white rounded font-medium shadow-md uppercase tracking-wide text-[12px] hover:shadow-lg duration-300 ease-in-out"
                    >
                        {saveicon ? <i className={saveicon}></i> : <i className="fa">&#xf0c7;</i>}  {savetext}
                    </button>
                </>
            )}
            {cancel && (
                <button
                    onMouseMove={handleMouseMove}
                    type="button"
                    ref={btnRef}
                    name={id}
                    onClick={handleCancel}
                    className="px-4 py-2 bg-red-600 text-white rounded font-medium 
                   uppercase tracking-wide text-sm 
                   hover:bg-red-700 transition-all duration-200"
                >
                    <i className="fa fa-times"></i> Cancel
                </button>
            )}
            {update && (
                <button
                    onMouseMove={handleMouseMove}
                    type="button"
                    ref={btnRef}
                    name={id}
                    onClick={handleSubmit}
                    className="ripple-btn px-4 py-2 bg-[var(--theme-color)] text-white rounded font-medium shadow-md uppercase tracking-wide text-sm transition-all hover:shadow-lg duration-300 ease-in-out"
                >
                    <i className="fa fa-upload"></i>
                    Update
                </button>
            )}
            {/*{cancel && (*/}
            {/*    <button*/}
            {/*        onMouseMove={handleMouseMove}*/}
            {/*        type="button"*/}
            {/*        ref={btnRef}*/}
            {/*        name={id}*/}
            {/*        onClick={handleCancel}*/}
            {/*        className="ripple-btn px-4 py-2 bg-gradient-to-r from-green-400 via-green-500 to-green-600 text-white rounded font-medium shadow-md uppercase tracking-wide text-sm hover:from-green-500 hover:via-green-600 hover:to-green-700 transition-all hover:shadow-lg duration-300 ease-in-out"*/}
            {/*    >*/}
            {/*        <i className="fa fa-upload"></i>*/}
            {/*        Cancel*/}
            {/*    </button>*/}
            {/*)}*/}

            {Export && (
                <button
                    onMouseMove={handleMouseMove}
                    type="button"
                    ref={btnRef}
                    name={id}
                    onClick={handleExport}
                    className="ripple-btn px-4 py-2 bg-[#41942d] text-white rounded font-medium shadow-md uppercase tracking-wide text-[12px] transition-all hover:shadow-lg duration-300 ease-in-out"
                >
                    <i className="fa fa-download"></i> {"Export"}
                </button>
            )}

            {Reset && (
                <button
                    onMouseMove={handleMouseMove}
                    type="button"
                    ref={btnRef}
                    name={id}
                    onClick={handleClear}
                    className="ripple-btn px-4 py-2 bg-[#dc3545] text-white rounded font-medium shadow-md uppercase tracking-wide text-[12px] transition-all hover:shadow-lg duration-300 ease-in-out"
                >
                    <i className="fa-solid fa-arrow-rotate-left"></i> {resetText}

                </button>
            )}

            {isPrint && (
                <button
                    onMouseMove={handleMouseMove}
                    type="button"
                    ref={btnRef}
                    name={id}
                    onClick={handlePrint}
                    className="ripple-btn px-4 py-2 bg-[var(--theme-color)] text-white rounded font-medium shadow-md uppercase tracking-wide text-sm transition-all hover:shadow-lg duration-300 ease-in-out"
                >
                    <i className="fa-solid fa-print"></i> {PrintText}

                </button>
            )}
            {isPrint1 && (
                <button
                    onMouseMove={handleMouseMove}
                    type="button"
                    ref={btnRef}
                    name={id}
                    onClick={handlePrint1}
                    className="ripple-btn px-4 py-2 bg-[var(--theme-color)] text-white rounded font-medium shadow-md uppercase tracking-wide text-sm duration-300 ease-in-out"
                >
                    <i className="fa-solid fa-print"></i> {PrintText1}

                </button>
            )}

            {LabelPrint && (
                <button
                    onMouseMove={handleMouseMove}
                    type="button"
                    ref={btnRef}
                    name={id}
                    onClick={handleLabelPrint}
                    className="ripple-btn px-4 py-2 bg-[var(--theme-color)] text-white rounded font-medium shadow-md uppercase tracking-wide text-sm duration-300 ease-in-out"
                >
                    <i className="fa-solid fa-print"></i> {"Label Print"}

                </button>
            )}
            {SeeAndPrint && (
                <button
                    onMouseMove={handleMouseMove}
                    type="button"
                    ref={btnRef}
                    name={id}
                    onClick={handleSeeAndPrint}
                    className="ripple-btn px-4 py-2 bg-[var(--theme-color)] text-white rounded font-medium shadow-md uppercase tracking-wide text-sm duration-300 ease-in-out"
                >
                    <i className="fa-solid fa-print"></i> {"CN Print"}

                </button>
            )}
            {InvoicePrint && (
                <button
                    onMouseMove={handleMouseMove}
                    type="button"
                    ref={btnRef}
                    name={id}
                    onClick={handleInvoicePrint}
                    className="ripple-btn px-4 py-2 bg-gradient-to-r from-sky-600 via-purple-700 to-pink-700 text-white rounded font-medium shadow-md uppercase tracking-wide text-sm hover:from-red-500 hover:via-red-600 hover:to-red-700 transition-all hover:shadow-lg duration-300 ease-in-out"
                >
                    <i className="fa-solid fa-print"></i> {"Bulk Invoice Print"}

                </button>
            )}
            {children}
        </div>
    );
};

export const TextAreaBox = (props) => {
    let { divclassname = 'col-md-3 mb-1 cntrl-width ', renderinput = null, key = '', rows = '3', labelclass = 'form-label', onKeyDown = null, onBlur = null, inputclassname = 'form-control', type = 'text', divstyle = null, inputstyle = null, disabled = false, inputrefs, id, label = '', value, onChange, placeholder, required } = props
    return (
        <div
            className={`${divclassname}`}
            style={divstyle}
            key={key}
        >
            {label !== '' ? <label style={{ 'whiteSpace': 'nowrap' }} className={labelclass} htmlFor={id}>{label}
                {required ? <span style={{ color: "red" }}> *</span> : <></>}
            </label> : <></>}
            <textarea
                id={id}
                style={inputstyle}
                onKeyDown={onKeyDown}
                ref={ref => (inputrefs.current[id] = ref)}
                className={`${inputclassname}`}
                rows={rows}
                value={value}
                onChange={onChange}
                disabled={disabled}
                placeholder={placeholder}
                autoComplete="off"
                onBlur={onBlur}
                title={required ? 'Please fill this field.' : ''}
                {...props}
            />
            {renderinput}

        </div>
    )
}
export const ImportButton = ({ BulkSubmit, handleBulk, downloadFormat, children, Status = [], ErrorData, fileName = '',
    extraElement = false,
    setIsBulkEditDelete, isBulkEditDelete, isAdd = true, isUpdate = true, isDelete = true }) => {

    return (
        <div className="w-full bg-white border  border-gray-200 rounded-xl px-4 py-3 shadow-sm">

            {/* Label */}
            <label className="text-gray-800 font-medium mb-2 block">
                Bulk Upload <span className="text-red-500">*</span>
            </label>

            {/* Radio Buttons */}
            {extraElement && (
                <div className="flex items-center gap-6 mb-2 text-sm text-gray-700">
                    {isAdd && <label className="flex items-center gap-2 cursor-pointer">

                        <input
                            type="radio"
                            name="isbulkEditUpdate"
                            value="insert"
                            checked={isBulkEditDelete === "insert"}
                            onChange={(e) => setIsBulkEditDelete(e.target.value)}
                            className="text-blueled focus:ring-blueled"
                        />
                        Add
                    </label>
                    }
                    {isUpdate && <label className="flex items-center gap-2 cursor-pointer">
                        <input
                            type="radio"
                            name="isbulkEditUpdate"
                            value="update"
                            checked={isBulkEditDelete === "update"}
                            onChange={(e) => setIsBulkEditDelete(e.target.value)}
                            className="text-blueled focus:ring-blueled"
                        />
                        Update
                    </label>}

                    {isDelete && <label className="flex items-center gap-2 cursor-pointer">
                        <input
                            type="radio"
                            name="isbulkEditUpdate"
                            value="delete"
                            checked={isBulkEditDelete === "delete"}
                            onChange={(e) => setIsBulkEditDelete(e.target.value)}
                            className="text-blueled focus:ring-blueled"
                        />
                        Delete
                    </label>}
                </div>
            )}

            {/* Drop Zone */}
            <FileUploader
                classes="w-full"
                handleChange={BulkSubmit}
                types={["xlsx"]}
                children={
                    <div className="flex items-center justify-center gap-2 w-full py-4 border-2 border-dashed border-blueled rounded-lg cursor-pointer 
                hover:bg-teal-50 transition-all duration-200">
                        <i className="fa fa-upload text-blueled"></i>
                        <span className="text-gray-700">
                            {fileName ? fileName : "Upload Excel File (.xlsx)"}
                        </span>
                    </div>
                }
            />

            {/* Action Buttons */}
            <div className="flex items-center gap-4 mt-4">
                <button
                    type="button"
                    className="px-5 py-2 bg-[var(--theme-color)] hover:bg-[#356487] text-white text-sm rounded-md transition shadow-sm"
                    onClick={handleBulk}
                >
                    <i className="fa fa-upload ml-1"></i> Upload
                </button>
                <span
                    className="text-blueled text-sm underline cursor-pointer hover:text-blueled"
                    onClick={downloadFormat}
                >
                    Download Format <i className="fa fa-download ml-1"></i>
                </span>
            </div>

            {/* Status Display */}
            {Status?.SuccessCount >= 0 && (
                <div className="mt-4 text-sm font-medium flex items-center gap-6">
                    <span className="text-green-600">
                        Success : {Status?.SuccessCount}
                    </span>

                    <span className="text-red-500 flex items-center gap-1">
                        Error : {Status?.ErrorCount}
                        {Status?.ErrorCount > 0 && (
                            <i
                                className="fa fa-download cursor-pointer"
                                onClick={ErrorData}
                            ></i>
                        )}
                    </span>
                </div>
            )}

            {children}
        </div>

    )
}

export const InputBox = (props) => {
    let {
        divclassname = "w-full ",
        renderinput = null,
        key = "",
        labelclass = "",
        onKeyDown = null,
        inputclassname = "form-control",
        type = "text",
        divstyle = null,
        inputstyle = null,
        inputrefs,
        id,
        label = "",
        value,
        onChange,
        placeholder,
        required,
        extraElement,
        isPasswordField = false,
        showPassword = false,
        togglePassword = () => { }
    } = props;

    return (
        <div className={`${divclassname} relative`} style={divstyle} key={key}>
            {label !== "" && (
                <label
                    style={{ whiteSpace: "nowrap" }}
                    className={`${labelclass} block text-sm font-medium text-gray-700 mb-1`}
                    htmlFor={id}
                >
                    {label}
                    {required && <span style={{ color: "red" }}> *</span>}
                    {extraElement}
                </label>
            )}

            <input
                id={id}
                style={inputstyle}
                onKeyDown={onKeyDown}
                ref={(ref) => {
                    if (inputrefs?.current && id) {
                        inputrefs.current[id] = ref;
                    }
                }}
                type={isPasswordField ? (showPassword ? "text" : "password") : type}
                className={`${inputclassname} block w-full border border-gray-300  focus:ring-1 focus:ring-blueled focus:border-transparent transition duration-200 outline-none`}
                value={value}
                onChange={onChange}
                placeholder={placeholder}
                autoComplete="off"
                title={required ? "Please fill this field." : ""}
                {...props}
            />

            {/* Password Toggle Icon */}
            {isPasswordField && (
                <span
                    className="absolute right-5 top-[34px] cursor-pointer text-gray-500"
                    onClick={togglePassword}
                >
                    {showPassword ? (
                        <EyeOff size={18} className="text-[#3C768E]" />
                    ) : (
                        <Eye size={18} className="text-[#3C768E]" />
                    )}
                </span>
            )}

            {renderinput}
        </div>
    );
};

export const InputGroupBox = (props) => {
    const {
        divclassname = "w-full ",
        name, id, maxLength, inputstyle,
        disabled, onKeyDown, onChange, onClick,
        pattern, type = "text", value, placeholder,
        label, required, startBoxClass = "",
        startIcon, startText, handleStartButtonClick,
        endBoxClass = "", endIcon, endText,
        handleEndButtonClick, inputrefs
    } = props;

    return (
        <div className={`Input_Group ${divclassname}`}>

            {/* Label */}
            {label && (
                <label
                    htmlFor={id}
                    className="block text-sm font-medium text-gray-700 mb-0 whitespace-nowrap"
                    title={label}
                >
                    {label}
                    {required && <span className="text-red-600"> *</span>}
                </label>
            )}

            <div className="relative flex items-center m-1 rounded-md border border-gray-300 bg-white focus-within:ring-1 focus-within:ring-blueled focus-within:border-transparent transition duration-200">

                {/* Start Icon / Text */}
                {(startIcon || startText) && (
                    <div
                        onClick={handleStartButtonClick}
                        className={`px-2 py-2 cursor-pointer select-none border-r border-gray-300 transition rounded-l-md ${startBoxClass}`}
                        style={{ backgroundColor: "var(--theme-color)" }}
                    >
                        {startIcon && <i className={`${startIcon} text-sm text-white`} />}
                        {startText && <span className="text-sm text-white">{startText}</span>}
                    </div>
                )}

                {/* Input Field */}
                <input
                    onClick={onClick}
                    className="block w-full px-3 py-[3px] text-sm text-gray-700 focus:outline-none "
                    name={name}
                    id={id}
                    ref={(ref) => {
                        if (inputrefs && inputrefs.current) {
                            inputrefs.current[id] = ref;
                        }
                    }}
                    maxLength={maxLength}
                    style={inputstyle}
                    disabled={disabled}
                    onKeyDown={onKeyDown}
                    onChange={onChange}
                    pattern={pattern}
                    type={type}
                    value={value}
                    placeholder={placeholder}
                    autoComplete="off"
                />

                {(endIcon || endText) && (
                    <div
                        onClick={handleEndButtonClick}
                        className={`px-2 py-2 text-gray-600 cursor-pointer select-none border-l border-gray-300 bg-gray-100 hover:bg-gray-200 transition rounded-r-md ${endBoxClass}`}
                    >
                        {endIcon && <i className={`${endIcon} text-sm mx-1`} />}
                        {endText && <span className="text-sm">{endText}</span>}
                    </div>
                )}
            </div>
        </div>
    );
};

export const AutoCompleteBoxNew = (props) => {
    const { divclassname = 'w-full ', onKeyDown, style, divstyle, inputstyle, inputrefs, maxLength, label = '', nextFocus = ''
        , placeholder, required, value, autocompleteType = '', contextKey = '', contextKey2 = '', contextKey3 = '', contextKey4 = '', contextKey5 = '', renderinput = null,
        Options, onfocusevent = false, isLocalOption = false, ...restProps } = props;

    const { id, multiple = false } = restProps

    const autoCompleteTimeoutRef = useRef(null);
    const [autoCompleteOptions, setAutoCompleteOptions] = useState([]);
    const [inputValue, setInputValue] = useState(value);
    useEffect(() => {
        setInputValue(value);
    }, [value]);

    const commonData = CommonApiData()
    let Data = {
        "authToken": commonData.AuthToken,
        "loginToken": commonData.LoginToken,
        "userCode": commonData.UserCode,
        "loginUserGroupID": commonData.loginUserGroupID,
    };
    const handleAutoCompleteChange = (event, prefix) => {
        if (isLocalOption) {
            setAutoCompleteOptions(Options ? Options : []);
        } else {
            if (autoCompleteTimeoutRef.current) {
                clearTimeout(autoCompleteTimeoutRef.current);
            }
            autoCompleteTimeoutRef.current = setTimeout(async () => {
                const autoOptions = await FetchAutoCompleteData(Data, prefix, autocompleteType, contextKey, contextKey2, contextKey3, contextKey4, contextKey5);
                setAutoCompleteOptions(autoOptions ? autoOptions : []);
            }, autoCompleteDelay);
        }
    };

    return (
        <div
            className={`${divclassname} `}
            style={style || divstyle}
        >
            {label === '' ? '' :
                <label className="block text-sm font-medium text-gray-700 mb-1" htmlFor={id}>
                    {label}
                    {required && <span className="text-red-600"> *</span>}
                </label>
            }
            <Autocomplete
                value={inputValue}
                freeSolo
                className={`block w-full border rounded-md focus:ring-1 focus:ring-blue-500 focus:border-transparent transition duration-200 outline-none`}
                multiple={multiple}
                autoComplete
                autoSelect={true}
                autoHighlight={inputValue ? false : true} // auto highlight first option
                selectOnFocus={true} // auto select all input text like jquery select
                includeInputInList
                filterOptions={(x) => x} // for accepting every input like (.)
                options={autoCompleteOptions}
                isOptionEqualToValue={(option, value) => multiple && option === value} // auto select option when set value from state
                onInputChange={
                    (event, newInputValue, reason) => {
                        if (reason && newInputValue && reason === 'input') {
                            handleAutoCompleteChange(event, newInputValue);
                        }
                        else {
                            if (autoCompleteOptions) {
                                setAutoCompleteOptions([]);
                            }
                        }
                    }}
                onClose={(event, reason) => {
                    if (autoCompleteOptions) {
                        setAutoCompleteOptions([]);
                    }
                }}
                onOpen={(event) => {
                    if (onfocusevent) {
                        handleAutoCompleteChange(event, '.');
                    }
                }}
                openOnFocus={true}
                title={required ? 'Please fill this field.' : ''}
                renderInput={(params) => <TextField
                    {...params}
                    onInput={(e) => {
                        const { value } = e.target;
                        if (value.length > maxLength) {
                            e.target.value = value.slice(0, maxLength);
                        }
                    }}
                    inputRef={ref => (inputrefs.current[id] = ref)}

                    FormHelperTextProps={{
                        sx: { marginLeft: 0 },
                    }}
                    placeholder={placeholder}
                    onKeyDown={onKeyDown}
                    autoComplete="off"
                />}
                {...restProps}
            />
            {renderinput}
        </div>
    )
}

export const AutoCompleteBoxNumeric = (props) => {
    const { divclassname = 'w-full ', onKeyDown, style, divstyle, inputstyle, inputrefs, maxLength, label = '', nextFocus = ''
        , placeholder, required, value, autocompleteType = '', contextKey = '', contextKey2 = '', contextKey3 = '', contextKey4 = '', contextKey5 = '', renderinput = null,
        Options, onfocusevent = false, isLocalOption = false, ...restProps } = props;

    const { id, multiple = false } = restProps

    const autoCompleteTimeoutRef = useRef(null);
    const [autoCompleteOptions, setAutoCompleteOptions] = useState([]);
    const [inputValue, setInputValue] = useState(value);
    useEffect(() => {
        setInputValue(value);
    }, [value]);

    const commonData = CommonApiData()
    let Data = {
        "authToken": commonData.AuthToken,
        "loginToken": commonData.LoginToken,
        "userCode": commonData.UserCode,
        "userGroupID": commonData.loginUserGroupID,
    };
    const handleAutoCompleteChange = (event, prefix) => {
        if (isLocalOption) {
            setAutoCompleteOptions(Options ? Options : []);
        } else {
            if (autoCompleteTimeoutRef.current) {
                clearTimeout(autoCompleteTimeoutRef.current);
            }
            autoCompleteTimeoutRef.current = setTimeout(async () => {
                const autoOptions = await FetchAutoCompleteData(Data, prefix, autocompleteType, contextKey, contextKey2, contextKey3, contextKey4, contextKey5);
                setAutoCompleteOptions(autoOptions ? autoOptions : []);
            }, autoCompleteDelay);
        }
    };

    return (
        <div
            className={`${divclassname}`}
            style={style || divstyle}
        >
            {label === '' ? '' :
                <label className="block text-sm font-medium text-[#535353] mb-1" htmlFor={id}>
                    {label}
                    {required && <span className="text-red-600"> *</span>}
                </label>
            }
            <Autocomplete
                value={inputValue}
                freeSolo
                className={`block w-full border rounded-md focus:ring-1 focus:ring-blue-500 focus:border-transparent transition duration-200 outline-none`}
                multiple={multiple}
                autoComplete
                autoSelect
                autoHighlight={inputValue ? false : true}
                selectOnFocus={true}
                includeInputInList
                filterOptions={(x) => x}
                options={autoCompleteOptions}
                isOptionEqualToValue={(option, value) => multiple && option === value}
                onInputChange={
                    (event, newInputValue, reason) => {
                        if (reason && newInputValue && reason === 'input') {
                            handleAutoCompleteChange(event, newInputValue);
                        }
                        else {
                            if (autoCompleteOptions) {
                                setAutoCompleteOptions([]);
                            }
                        }
                    }}
                onClose={(event, reason) => {
                    if (autoCompleteOptions) {
                        setAutoCompleteOptions([]);

                    }
                }}
                onOpen={(event) => {
                    if (onfocusevent) {
                        handleAutoCompleteChange(event, '.');
                    }
                }}
                openOnFocus={true}
                title={required ? 'Please fill this field.' : ''}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        onInput={(e) => {
                            const { value } = e.target;
                            const numericValue = value.replace(/[^0-9]/g, '');
                            if (value !== numericValue) {
                                e.target.value = numericValue;
                            }
                            if (numericValue.length > maxLength) {
                                e.target.value = numericValue.slice(0, maxLength);
                            }
                        }}
                        inputRef={(ref) => (inputrefs.current[id] = ref)}
                        sx={inputstyle}
                        placeholder={placeholder}
                        onKeyDown={onKeyDown}
                        autoComplete="off"
                    />
                )}

                {...restProps}
            />
            {renderinput}
        </div>
    )
}

export const DateBox = (props) => {
    const {
        divclassname = "w-full ",
        datepikerclass = "",
        labelstyle,
        style,
        inputstyle,
        label = "",
        onKeyDown,
        selected,
        placeholder,
        id,
        inputrefs,
        onChange,
        required,
        extraElement
    } = props;

    const validDateInput = function (e) {
        e.target.value = "";
    };

    return (
        <div className={`${divclassname} relative`} style={style}>
            {label && (
                <label
                    className="block text-sm font-medium text-gray-700 mb-1"
                    style={labelstyle}
                >
                    {label}
                    {required && <span className="text-red-600"> *</span>}
                    {extraElement && extraElement}
                </label>
            )}

            <DatePicker
                className={`block w-full border border-gray-300 rounded-md px-3 py-2 text-sm
                            focus:ring-1 focus:ring-blueled focus:border-transparent
                            transition duration-200 outline-none ${datepikerclass}`}
                style={inputstyle}
                dateFormat="dd-MMM-yyyy"
                placeholderText={placeholder}
                selected={selected}
                ref={(ref) => (inputrefs.current[id] = ref?.input)}
                onKeyDown={onKeyDown}
                showYearDropdown
                showMonthDropdown
                yearDropdownItemNumber={100}
                scrollableYearDropdown
                preventOpenOnFocus={true}
                onChange={onChange}
                onChangeRaw={(e) => validDateInput(e)}
                autoComplete="off"
                title={required ? "Please fill this field." : ""}
                {...props}
            />
        </div>
    );
};

export const SelectInputBox = (props) => {
    const { divclassname = 'w-full ', inputclassname = '', onKeyDown, divstyle, inputstyle, inputrefs, id, label = '', value = '', onChange, children, required = false } = props
    return (
        <div
            className={` ${divclassname} `}
            style={divstyle}
        >
            {label === '' ? '' :
                <label className="block text-sm font-medium text-gray-700 mb-1" htmlFor={id}>{label || 'Branch'}
                    {required ? <span style={{ color: "red" }}> *</span> : <></>}
                </label>}
            <select
                id={id}
                className={`form-select block w-full border border-gray-300  focus:ring-1 focus:ring-blueled focus:border-transparent transition duration-200 outline-none ${inputclassname}`}
                style={inputstyle}
                onKeyDown={onKeyDown}
                ref={ref => (inputrefs.current[id] = ref)}
                value={value}
                onChange={onChange}
                title={required ? 'Please select an item in the list.' : ''}
                autoComplete="off"
                {...props}
            >
                {children}
            </select>
        </div>
    )
}

export const Switch = (props) => {
    const {
        id,
        checked = false,
        inputrefs,
        onKeyDown,
        label,
        lableClassName = 'block text-sm font-medium text-gray-700 ',
        onChange,
        divclassname = 'w-full',
        labelclass = 'flex items-center gap-2 cursor-pointer select-none mt-2',
        ...rest
    } = props;

    return (
        <div className={`${divclassname}`} key={`checkin${id}`}>
            <label className={`${labelclass}`}>
                <input
                    type="checkbox"
                    id={id}
                    checked={checked}
                    onChange={onChange}
                    onKeyDown={onKeyDown}
                    ref={(ref) => (inputrefs.current[id] = ref)}
                    className="sr-only peer"
                    autoComplete="off"
                    {...rest}
                />

                <div className="
                    w-10 h-5 bg-gray-300 rounded-full relative
                    peer-focus:ring-1 peer-focus:ring-blueled
                    peer-checked:bg-blue-600 transition-all duration-200
                "></div>

                <div className="
                        absolute w-3 h-3 bg-white rounded-full shadow
                        transition-transform duration-200 pointer-events-none
                        peer-checked:translate-x-5 ml-1 
                    "
                ></div>

                {/* Label */}
                <span className={lableClassName}>{label}</span>
            </label>
        </div>
    );
};

export const RadioButton = (props) => {
    const { id, name, value, checked = false, inputrefs, onKeyDown, label, onChange, extraclassname = 'form-check form-radio ps-4 mt-3 me-2', lableClassName = 'form-check-label ms-2', divclassname = 'col-md-3 mb-1 cntrl-width' } = props;
    return (
        <div className={`${divclassname}`} key={`radio${id}`}>
            <div className={`${extraclassname}`}>
                <input
                    className="form-check-input cursor-pointer"
                    type="radio"
                    id={id}
                    name={name}
                    value={value}
                    checked={checked}
                    onChange={onChange}
                    onKeyDown={onKeyDown}
                    ref={ref => (inputrefs?.current && (inputrefs.current[id] = ref))}
                    {...props}
                />
                <label className={`${lableClassName} cursor-pointer`} htmlFor={id}>{label}</label>
            </div>
        </div>
    )
}

export const CheckBoxInput = (props) => {
    const { id, checked = false, maindivclassname = 'w-full', divclassname = ``, labelclassname = "form-check-label ms-2", inputrefs, onKeyDown, label = '', onChange } = props
    return (
        <div className={`cursor-pointer ${maindivclassname}`} key={`checkin${id}`}>
            <div className={divclassname}>
                <input
                    className="cursor-pointer"
                    type="checkbox"
                    id={id}
                    checked={checked}
                    onChange={onChange}
                    onKeyDown={onKeyDown}
                    ref={ref => (inputrefs.current[id] = ref)}
                    {...props}
                />
                {label !== '' && <label className={`${labelclassname} cursor-pointer`} htmlFor={id}>{label}</label>}
            </div>
        </div>
    )
}

export const MessageBoxAlert = React.memo(({ Msg = '', clearMessage, Status, uniqueId }) => {
    const audio = useMemo(() => new Audio(Status !== 'SUCCESS' ? './Sound/Error.mp3' : './Sound/Success.mp3'), [Status]);

    const handleClearMessage = useCallback(() => {
        clearMessage();
    }, [clearMessage]);
    let enableNotificationSound = false;
    if (GetSession('localStorage', 'enableNotificationSound') === 'true') {
        enableNotificationSound = true;
    }
    else if (GetSession('localStorage', 'enableNotificationSound') === null) {
        enableNotificationSound = true;
    }
    if (Msg !== '' && uniqueId) {
        if (enableNotificationSound) {

            audio.play();
        }
    }

    return (
        <>
            {Msg === '' ? '' :
                <div className='container-fluid p-0 m-0 pt-1 '>
                    <div className='col-md-12 col-lg-12 col-12 px-3 py-2 rounded' style={{ background: Status !== 'SUCCESS' ? '#ff7070' : '#68d95b96', color: '#172b64', fontWeight: '500' }}>
                        {Msg}
                        <span style={{ float: 'right', cursor: 'pointer' }} onClick={handleClearMessage}>X</span>
                    </div>
                </div>
            }
        </>
    );
});

export const TimeBox = (props) => {
    let { divclassname = 'w-full ', key = '', hideclock = true, labelclass = 'form-label', inputstyle, onKeyDown = null, inputclassname = '', divstyle = null, inputrefs, id, label = '', value, onChange, placeholder, required } = props

    const findFirstEnabledVisibleInput = (parent) => {
        if (!parent) return null;
        const isVisible = (elem) => !!(elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length);
        const inputs = parent.querySelectorAll('input');
        for (let input of inputs) {
            if (!input.disabled && isVisible(input)) {
                return input;
            }
        }
        return null;
    };

    return (
        <div
            className={`${divclassname}`}
            style={divstyle}
        >
            {label !== '' ? <label style={{ 'whiteSpace': 'nowrap' }} className={labelclass} htmlFor={id}>{label}
                {required ? <span style={{ color: "red" }}> *</span> : <></>}
            </label> : <></>}
            <div
                ref={ref => {
                    const firstEnabledVisibleInput = findFirstEnabledVisibleInput(ref);
                    inputrefs.current[id] = firstEnabledVisibleInput;
                }}
                className='TimeBox'
                key={key}
            >
                <ReactTimePicker
                    value={value}
                    style={inputstyle}
                    onChange={onChange}
                    format="HH:mm"
                    clockIcon=''
                    placeholder={placeholder}
                    disableClock={hideclock}
                    autoComplete="off"
                    title={required ? 'Please fill this field.' : ''}
                    id={id}
                    onKeyDown={onKeyDown}
                    className={`form-control ${inputclassname}`}
                    {...props}
                />

            </div>
        </div>
    )
}

export const DragComponent = (paperProps) => (
    <Draggable
        handle="#alert-dialog-title"
        cancel={'[class*="MuiDialogContent-root"]'}
    >
        <div
            {...paperProps}
            style={{
                backgroundColor: 'white',
                boxShadow: 'none',
                minWidth: '400px',
                ...paperProps.style
            }}
        />
    </Draggable>
);

export const LineChartComponent = ({ Data = [], onClickHandler, width, height, showLegend = true }) => {
    let displayData = Data && Data.length > 0 ? Data.map(item => ({
        ...item,
        amount: Number(item.amount),
    })) : [];
    return <LineChart
        width={width} height={height}
        data={displayData}
        margin={{
            top: 15,
            right: 25,
            left: 0,
            bottom: 15,
        }}
        onClick={onClickHandler}
    >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis
            dataKey="title"
            tick={{ fontSize: 14 }}
            interval={0}
            angle={-25}
            textAnchor="end"
        />
        <YAxis tick={{ fontSize: 8 }} />
        <Tooltip />
        {showLegend && <Legend />}
        <Line dataKey="amount" stroke="#82ca9d" />
    </LineChart>
}

export const MovementHistory = (props) => {
    const { movementHistoryData, height = "40vh", handleCloseMenuList, closeIconShow = false } = props;
    var data = [];
    for (let i = 0; i < movementHistoryData.length; i++) {
        data.push({
            label: (
                <p>
                    {(movementHistoryData[i]?.statusDate)?.split(' ')[0]}
                    <br />
                    <i className="text-secondary">{(movementHistoryData[i]?.statusDate)?.split(' ')[1]}</i>
                </p>
            ),
            children: (
                <p>
                    <h6 className='m-0 p-0'>{movementHistoryData[i]?.packetStatus}</h6>
                    <span>{movementHistoryData[i]?.statusDetails}</span>
                    <br />
                    {movementHistoryData[i]?.podLocation && <i className="text-success">{movementHistoryData[i]?.podLocation}</i>}
                </p>
            ),
        });
    }
    return (
        movementHistoryData?.length > 0 && <div className='col-12 mx-0 border'>
            <div className="">
                <div className='card-header border-bottom d-flex justify-content-between w-100' style={{ padding: '0px 0px', backgroundColor: 'gray', color: '#fff' }}>
                    <p className="py-1 px-2" style={{ fontFamily: 'sans-serif', fontWeight: 500, lineHeight: 1.1, color: '#fff', marginBottom: '0px' }} >{"Tracking History"}</p>
                    {closeIconShow &&
                        <i
                            className="fa fa-times close-icon"
                            onClick={handleCloseMenuList}
                            title="Close"
                            style={{ cursor: 'pointer', padding: "8px" }}
                        ></i>
                    }
                </div>
            </div>
            <div mode="alternate" style={{ paddingTop: "20px", backgroundColor: "var(--main-card)", height: height, overflowY: "auto", overflowX: "hidden" }}>
                <Timeline
                    mode='left'
                    items={data}
                />
            </div>
        </div>
    )
}

export const TextareaBox = (props) => {
    let toUpperCase = GetSession('cookies', 'isUpperCase');
    const { divclassname = "w-full ", rows, name, zoom, inputrefs, onChange, label, error, onClick, id, divstyle, maxLength, value, required, inputstyle, onKeyDown, onFocus, InfoDetails, onBlur, pattern, type = "text", inputclassname, placeholder, disabled } = props;
    const [zoomIn, setZoomIn] = useState(false);

    const handleZoomIn = async () => {
        await setZoomIn(true);
    }
    const handleZoomOut = async () => {
        await setZoomIn(false);
    }
    return (
        <div className={`fields ${divclassname} ${zoom && "position-relative"}`} style={divstyle}>
            {label !== "" && label && <label className={`block text-sm font-medium text-gray-700 mb-1 ${error && value?.trim() === "" && "text-error-color"}`} title={label}>{label}{required && <span className="text-danger">*</span>}</label>
            }
            <textarea
                rows={rows}
                className={`${inputclassname} block w-full border border-gray-300  focus:ring-1 focus:ring-blueled focus:border-blue-500 transition duration-200 outline-none`}
                id={id}
                name={name}
                maxLength={maxLength}
                style={inputstyle}
                disabled={disabled}
                ref={ref => (inputrefs.current[id] = ref)}
                onKeyDown={onKeyDown}
                onChange={onChange}
                onFocus={onFocus}
                onBlur={onBlur}
                onClick={onClick}
                pattern={pattern}
                type={type ? type : "text"}
                value={toUpperCase && typeof value === 'string' ? value.toUpperCase() : value || ''}
                placeholder={placeholder}
                autoComplete="off"
            />
            {zoom && (zoomIn ? <i className="fa-solid fa-compress arrow zoom-icon-placement" onClick={() => handleZoomOut()}></i> :
                <i className="fas fa-expand arrow zoom-icon-placement" onClick={() => handleZoomIn()}></i>
            )}
            {error && value?.trim() === "" && <div className="error-msg">{error}</div>}

            {zoomIn &&
                <Dialog
                    open={zoomIn}
                    onClose={handleZoomOut}
                    keepMounted
                    maxWidth="md"
                    fullWidth
                    TransitionComponent={Zoom}
                    TransitionProps={{ timeout: { enter: 1000, exit: 500 } }}
                >

                    <textarea
                        rows={rows}
                        className={`form-control ${inputclassname} ${error && value?.trim() === "" && "border-error-color"}`}
                        id={id}
                        name={name}
                        maxLength={maxLength}
                        style={inputstyle}
                        disabled={disabled}
                        onKeyDown={onKeyDown}
                        onChange={onChange}
                        onFocus={onFocus}
                        onBlur={onBlur}
                        onClick={onClick}
                        pattern={pattern}
                        type={type ? type : "text"}
                        value={value}
                        placeholder={placeholder}
                        autoComplete="off"
                    />
                </Dialog>
            }
        </div>
    )
}

export const CustomCard = (props) => {
    const { children, heading, customPadding, heading_title, headingClassname, addon_heading, boxMainDivClass, boxMainDivStyle, headingBordercolor = '', headBorder = '', boxBorder = false, boxBorderColor = '', headingIcon, borderTopColor,
        borderTop = '0', borderRight = '0', borderLeft = '0', borderBottom = '0', height = "auto", ref, rest, openBox, setOpenBox, toggleOpenBox = false
    } = props

    return (
        <div className={`${customPadding} ${boxMainDivClass} `} style={boxMainDivStyle} ref={ref} {...rest}>
            <div className="main-card rounded-2" style={boxBorder ? { borderTop: borderTopColor && `2px solid ${borderTopColor}`, borderWidth: `${borderTop}px ${borderRight}px ${borderBottom}px ${borderLeft}px`, borderStyle: "solid", borderColor: boxBorderColor || headingBordercolor } : { borderTop: borderTopColor && `2px solid ${borderTopColor}` }}>
                {heading && <div onClick={toggleOpenBox ? (() => setOpenBox(!openBox)) : undefined}
                    className={`headingstyle heading_textsize position-relative ${headingClassname} ${addon_heading ?
                        "d-lg-flex d-md-flex d-sm-flex gap-2" :
                        ""} `}
                    style={toggleOpenBox ? { background: "var(--bg-light)", cursor: "pointer" } : {}}>
                    <h6 style={heading_title && headingBordercolor ? {
                        display: "inline",
                        background: headingBordercolor,
                        borderRadius: "7px 24px 24px 7px",
                        padding: "1px 15px",
                        position: "relative",
                        left: "-20px",
                        top: "-8px"
                    } : { display: "inline" }}>{headingIcon && <i className={headingIcon} style={{ zIndex: "100000" }}></i>}{heading_title}</h6>{addon_heading && addon_heading}
                    {toggleOpenBox && <div className='box_toggle_button' ><i onClick={() => setOpenBox(!openBox)} className={openBox ? 'fa-solid fa-chevron-up arrow p-1' : 'fa-solid fa-chevron-down arrow p-1'}></i></div>}

                </div>
                }
                {toggleOpenBox ?
                    <div className={`${openBox ? 'collapse show pb-2' : 'collapsed'}`} style={openBox ? { height: height, transition: 'all ease-in 0.6s', } : { height: '0px', transition: 'all ease-in 0.6s' }}>
                        {openBox && children}
                    </div>
                    :
                    <div className={`pb-3`} style={{ height: height, transition: 'all ease-in 0.6s', }}>
                        {children}
                    </div>
                }

            </div>
        </div>
    )
};
